import { Docket } from '@oolio-group/domain';

export interface DocketCountData {
  total: number;
  indices: Map<string, number>;
}

export type DocketCountsByOrderId = Map<string, DocketCountData>;

/**
 * Computes docket counts and indices for each order ID
 * @param dockets Array of dockets to process
 * @returns Map of order IDs to their count data and docket indices
 */
export const computeDocketCountsByOrderId = (
  dockets: Docket[],
): DocketCountsByOrderId => {
  const docketCountsByOrderId = new Map<string, DocketCountData>();

  dockets.forEach(docket => {
    if (docket.orderId) {
      if (!docketCountsByOrderId.has(docket.orderId)) {
        docketCountsByOrderId.set(docket.orderId, {
          total: 0,
          indices: new Map(),
        });
      }
      const orderGroup = docketCountsByOrderId.get(docket.orderId)!;
      orderGroup.indices.set(docket.id, orderGroup.total);
      orderGroup.total++;
    }
  });

  return docketCountsByOrderId;
};
